<div
  *ngFor="let newfield of field.fieldGroup; let i = index; let last = last"
  class="row"
>
  <formly-field [field]="newfield"></formly-field>
  <div
    *ngIf="field.fieldGroup"
    class="b-f-repeat-buttonbox"
    [ngClass]="{ 'align-right': !last, 'bottom-spacing': !props.showDivider }"
  >
    <button
      pButton
      *ngIf="!props.readOnly && last"
      (click)="add()"
      type="button"
      class="p-button-text"
      [label]="props.repeatButtonLabel"
      icon="symbol-add"
    ></button>
    <button
      pButton
      *ngIf="!props.readOnly && field.fieldGroup.length > 1"
      class="btn btn-danger p-button-text"
      type="button"
      (click)="remove(i)"
      [label]="props.removeButtonLabel ?? 'Remove'"
      icon="symbol-delete"
    ></button>
  </div>
  <p-divider *ngIf="!last && props.showDivider"></p-divider>
</div>
